export const LoyaltyCodes = {
    QFF: 'QFF',
} as const;
